import React from "react";
import { FC } from "react";

type Props = {
  isShowModal: boolean;
  closeModal:() => void;
};

const ItemModal:FC<Props>  = ({
  isShowModal,
  closeModal
})=> {  
  
  const modalState = !isShowModal ? 'hidden' : '';
  return (
    <div id="add-product-modal" className={`modal fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50 ${modalState}`}>
      <div className="modal-content relative mx-4 w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-md bg-white p-4 sm:p-8 shadow-lg">
        <div className="modal-header flex justify-between items-center mb-6 border-b pb-3">
          <h2 className="text-xl font-semibold text-gray-800">新規商品登録</h2>
          <button
            type="button" 
            className="close-button bg-none border-none text-gray-500 hover:text-gray-800 text-2xl cursor-pointer p-0"
            onClick={closeModal}
            >&times;
          </button>
        </div>
        <form id="add-product-form">
          <div className="form-group mb-4 text-left">
            <label htmlFor="product-name" className="block text-gray-700 text-sm font-bold mb-2">商品名</label>
            <input type="text" id="product-name" name="product-name" placeholder="商品名を入力してください" required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"/>
          </div>
          <div className="form-group mb-4 text-left">
            <label htmlFor="product-price" className="block text-gray-700 text-sm font-bold mb-2">金額</label>
            <input type="number" id="product-price" name="product-price" placeholder="金額を入力してください" required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"/>
          </div>
          <div className="form-group mb-4 text-left">
            <label htmlFor="product-description" className="block text-gray-700 text-sm font-bold mb-2">説明文</label>
            <textarea id="product-description" name="product-description" placeholder="商品の説明を入力してください"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline min-h-24"></textarea>
          </div>
          <div className="form-group mb-4 text-left">
            <label htmlFor="product-image" className="block text-gray-700 text-sm font-bold mb-2">画像</label>
            <input type="file" id="product-image" name="product-image" accept="image/*"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
            <small className="text-gray-500">推奨画像形式: JPG, PNG</small>
          </div>
          <div className="modal-actions text-right">
            <button
              type="button" 
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-2"
              onClick={closeModal}
            >
              キャンセル
            </button>
            <button type="submit" className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              登録
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ItemModal;